module.exports = __webpack_public_path__ + "assets/icons/img_cellular.svg";